import { Badge, rem } from 'ui';
import { IconArrowRight } from 'ui/Icons';

const InventoryAdjustmentIncrementBadge = ({ amount }: { amount: number }) => {
  return (
    <Badge
      type={amount > 0 ? 'primary' : 'warning'}
      miw={rem(55)}
      leftSection={
        <IconArrowRight
          size={12}
          style={{
            // arrow should point up if amount is positive, down if negative
            transform: amount > 0 ? 'rotate(-90deg)' : 'rotate(90deg)',
          }}
        />
      }
    >
      {amount > 0 ? '+' : '-'}
      {Math.abs(amount)}
    </Badge>
  );
};

export { InventoryAdjustmentIncrementBadge };
